import axios from 'axios';

import { API_URL } from '../constants';
import {
  accessToken as getAccessToken,
  refreshToken as getRefreshToken,
  setAccessToken,
  setRefreshToken
} from '../util/auth';
import { refreshToken } from './authApi';

const oAuthRequest = axios.create({
  timeout: 20000,
  // baseURL: 'https://merconnect-staging.herokuapp.com',
  baseURL: API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

oAuthRequest.interceptors.request.use(async config => {
  const accessToken = getAccessToken()
  config.headers.Authorization = `Bearer ${accessToken}`;
  return config;
});

oAuthRequest.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    // Timed-out / canceled requests have no response — must not throw here.
    if (error.response?.status === 401) {
      try {
        const response = await refreshToken(getRefreshToken());
        setAccessToken(response.data.access_token, localStorage.remember || false)
        setRefreshToken(response.data.access_token, localStorage.remember || false)

        const newConfig = {
          ...error.config,
          headers: {
            ...error.config.headers,
            Authorization: `Bearer ${response.data.accessToken}`
          }
        };
        return axios.request(newConfig);
      } catch {
        delete localStorage.accessToken
        delete localStorage.refreshToken
        window.location.reload()
        Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default oAuthRequest;
